import { Link } from "react-router-dom";
import "./index.style.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const copyrightName = "EsthétiqueBasilix";
  const copyrightDate = `${currentYear - 1}-${currentYear}`;

  return (
    <footer id="footer" className="text-sm text-white">
      <div className="footer-container">
        <div className="footer-content flex flex-col items-center gap-y-3 py-6 text-sm text-center">
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link
              to="/politique-confidentialite"
              className="text-white hover:underline"
            >
              Politique de confidentialité
            </Link>
            <Link
              to="/politique-cookies"
              className="text-white hover:underline"
            >
              Politique de cookies
            </Link>
            <Link to="/mentions-legales" className="text-white hover:underline">
              Mentions légales
            </Link>
          </nav>
          <p className="footer_text m-0">
            &copy; {copyrightDate} {copyrightName}
          </p>
        </div>
      </div>
    </footer>
  );
};
export { Footer };
